import React from 'react';
interface ControlPanelProps {
  theta: number;
  setTheta: (value: number) => void;
  phi: number;
  setPhi: (value: number) => void;
  coherence: number;
  setCoherence: (value: number) => void;
  label?: string;
}
export const ControlPanel: React.FC<ControlPanelProps> = ({
  theta,
  setTheta,
  phi,
  setPhi,
  coherence,
  setCoherence,
  label = 'QUANTUM CONTROLS'
}) => {
  return <div className="p-4 border-b border-white" data-id="element-24">
      <h2 className="text-xl font-bold mb-4 uppercase" data-id="element-25">{label}</h2>
      <div className="mb-4" data-id="element-26">
        <div className="flex justify-between mb-1" data-id="element-27">
          <label htmlFor="theta" className="text-sm" data-id="element-28">
            THETA (θ): {theta.toFixed(2)}
          </label>
          <span className="text-xs" data-id="element-29">[0 - π]</span>
        </div>
        <input id="theta" type="range" min="0" max={Math.PI} step="0.01" value={theta} onChange={e => setTheta(parseFloat(e.target.value))} className="w-full appearance-none h-2 bg-white rounded-none outline-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:border [&::-webkit-slider-thumb]:border-black [&::-webkit-slider-thumb]:rounded-none" data-id="element-30" />
        <div className="flex justify-between text-xs mt-1" data-id="element-31">
          <span data-id="element-32">POSITIVE</span>
          <span data-id="element-33">NEGATIVE</span>
        </div>
      </div>
      <div className="mb-4" data-id="element-34">
        <div className="flex justify-between mb-1" data-id="element-35">
          <label htmlFor="phi" className="text-sm" data-id="element-36">
            PHI (φ): {phi.toFixed(2)}
          </label>
          <span className="text-xs" data-id="element-37">[0 - 2π]</span>
        </div>
        <input id="phi" type="range" min="0" max={2 * Math.PI} step="0.01" value={phi} onChange={e => setPhi(parseFloat(e.target.value))} className="w-full appearance-none h-2 bg-white rounded-none outline-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:border [&::-webkit-slider-thumb]:border-black [&::-webkit-slider-thumb]:rounded-none" data-id="element-38" />
        <div className="flex justify-between text-xs mt-1 text-[0.6rem]" data-id="element-39">
          <span data-id="element-40">PERCEPTION</span>
          <span data-id="element-41">NOVELTY</span>
          <span data-id="element-42">GOAL</span>
          <span data-id="element-43">ACTION</span>
          <span data-id="element-44">PROGRESS</span>
          <span data-id="element-45">RESULT</span>
        </div>
      </div>
      <div className="mb-4" data-id="element-46">
        <div className="flex justify-between mb-1" data-id="element-47">
          <label htmlFor="coherence" className="text-sm" data-id="element-48">
            COHERENCE (c): {coherence.toFixed(2)}
          </label>
          <span className="text-xs" data-id="element-49">[0 - 1]</span>
        </div>
        <input id="coherence" type="range" min="0" max="1" step="0.01" value={coherence} onChange={e => setCoherence(parseFloat(e.target.value))} className="w-full appearance-none h-2 bg-white rounded-none outline-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:border [&::-webkit-slider-thumb]:border-black [&::-webkit-slider-thumb]:rounded-none" data-id="element-50" />
        <div className="flex justify-between text-xs mt-1" data-id="element-51">
          <span data-id="element-52">LOW AGENCY</span>
          <span data-id="element-53">HIGH AGENCY</span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-6" data-id="element-54">
        <button onClick={() => {
        setTheta(Math.PI / 4);
        setPhi(0);
        setCoherence(0.5);
      }} className="border-2 border-white p-2 hover:bg-white hover:text-black transition-colors" data-id="element-55">
          RESET
        </button>
        <button onClick={() => {
        setTheta(Math.random() * Math.PI);
        setPhi(Math.random() * 2 * Math.PI);
        setCoherence(Math.random());
      }} className="border-2 border-white p-2 hover:bg-white hover:text-black transition-colors" data-id="element-56">
          RANDOMIZE
        </button>
      </div>
    </div>;
};